import { camelCase, startCase } from 'lodash-es'

export default class Notification {
  constructor(notification) {
    this.notification = notification
  }

  viewerIsOwner(viewer) {
    return this._isSameEmployment(this.getOwner(), viewer)
  }

  viewerIsCreator(viewer) {
    return this._isSameEmployment(this.getCreator(), viewer)
  }

  actorIsOwner() {
    return this._isSameEmployment(this.getActor(), this.getOwner())
  }

  creatorIsOwner() {
    return this._isSameEmployment(this.getCreator(), this.getOwner())
  }

  getCreator() {
    return this.notification.data.creator
  }

  getOwner() {
    return this.notification.data.owner
  }

  getActor() {
    return this.notification.data.actor
  }

  getCreatedAt() {
    return this.notification.created_at
  }

  getKey() {
    return this.notification.id
  }

  routeQuery() {
    return {
      company: this._getCompanyKey(),
      [this.getType()]: this._getResourceKey(),
    }
  }

  getComponentName() {
    return startCase(camelCase(this.notification.type)).replace(/ /g, '')
  }

  isRead() {
    return !this.isUnread()
  }

  isUnread() {
    return this.notification.read_at === null
  }

  getType() {
    throw new Error('Method not implemented.')
  }

  viewerIsRequestOwner(viewer, type) {
    return this._isSameEmployment(this.getRequestOwner(type), viewer)
  }

  requestOwnerIsCommentator(type) {
    return this._isSameEmployment(
      this.getRequestOwner(type),
      this.getCommenter()
    )
  }

  getCommenter() {
    throw new Error('Method not implemented')
  }

  getRequestOwner(type) {
    return this.notification.data[type + '_owner']
  }

  _isSameEmployment(employment, other) {
    return Boolean(employment && other && employment.id === other.id)
  }

  _getCompanyKey() {
    return this.notification.data.company_id
  }

  _getResourceKey() {
    throw new Error('Method not implemented.')
  }
}
